// extracted by mini-css-extract-plugin
export default {"container":"quiz_answer-list-item_container__fn4JI","answerText":"quiz_answer-list-item_answerText__GffCA","questionIndex":"quiz_answer-list-item_questionIndex__Rmqg+"};